interface WalletIconProps {
  name: string;
  size?: number;
}

function TalismanIcon({ size = 24 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="8" fill="#D5FF5C" />
      <path d="M16 6C10.477 6 6 10.477 6 16s4.477 10 10 10 10-4.477 10-10S21.523 6 16 6z" fill="#1A1A1A" />
      <path d="M16 9a7 7 0 100 14A7 7 0 0016 9zm0 2a5 5 0 110 10A5 5 0 0116 11z" fill="#D5FF5C" />
    </svg>
  );
}

function PolkadotJsIcon({ size = 24 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="8" fill="#E6007A" />
      <circle cx="16" cy="16" r="6" fill="white" />
      <circle cx="16" cy="7" r="2.5" fill="white" />
      <circle cx="16" cy="25" r="2.5" fill="white" />
      <circle cx="7" cy="16" r="2.5" fill="white" />
      <circle cx="25" cy="16" r="2.5" fill="white" />
    </svg>
  );
}

function SubWalletIcon({ size = 24 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="8" fill="#4CEAAC" />
      <path d="M10 12h12M10 16h8M10 20h10" stroke="#1A1A1A" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  );
}

export default function WalletIcon({ name, size = 24 }: WalletIconProps) {
  if (name === 'talisman') return <TalismanIcon size={size} />;
  if (name === 'polkadot-js') return <PolkadotJsIcon size={size} />;
  if (name === 'subwallet-js') return <SubWalletIcon size={size} />;
  return (
    <div
      className="rounded-[6px] bg-[--base-border]"
      style={{ width: size, height: size }}
    />
  );
}
